<template>
	<div>
		<h3>
			<q-icon class="icon-fleche"/>
			Envoyez une carte postale à E. Macron
		</h3>

		<p>
			La déforestation bat son plein et Emmanuel Macron ne réagit pas&nbsp;? Peut-être préfère-t-il les bons vieux courriers.
		</p>

		<ol>
			<li>
				<a href="https://cdn.greenpeace.fr/site/uploads/2019/10/carte-postale-8.pdf" target="_blank" @click="track">Cliquez ici</a> pour télécharger la carte postale
			</li>
			<li>
				Imprimez-la
			</li>
			<li>
				Personnalisez-la si vous le souhaitez en écrivant un mot... en toute amabilité toujours.
			</li>
			<li>
				Postez votre carte postale à l’Elysée&nbsp;: l’adresse est déjà inscrite.
				<br/>
				Bon à savoir : pas besoin de timbre, l'affranchissement est gratuit jusqu’à 20 grammes.
			</li>
		</ol>

	</div>
</template>

<script>
export default {
	methods: {
		track() {
			this.$count()
			this.$trackEvent("click", "download carte postale")
		},
	}
}
</script>